import { render } from "./DataTransferView.vue?vue&type=template&id=397139ce&ts=true"
import script from "./DataTransferView.vue?vue&type=script&lang=ts"
export * from "./DataTransferView.vue?vue&type=script&lang=ts"

import "./DataTransferView.vue?vue&type=style&index=0&id=397139ce&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__